import { BrowserRouter, Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import Login from './Login';
import AuthGuard from './AuthGuard';
import RawAdminPage from '../../pages/Modules/AdminPage';

function normalizeBasePath(path, fallback) {
  const value = String(path || fallback).replace(/\/\*$/, '').replace(/\/+$/, '');
  return value || fallback;
}

export function CoreThemeAdminRoutes({
  loginPath = '/login',
  adminPath = '/admin',
  fallbackPath = '/',
}) {
  const navigate = useNavigate();
  const loginBase = normalizeBasePath(loginPath, '/login');
  const adminBase = normalizeBasePath(adminPath, '/admin');
  const adminRoutePath = `${adminBase}/*`;

  return (
    <Routes>
      <Route
        path={loginBase}
        element={(
          <Login
            defaultRedirectPath={adminBase}
            onLogin={() => navigate(adminBase, { replace: true })}
          />
        )}
      />
      <Route
        path={adminRoutePath}
        element={(
          <AuthGuard loginPath={loginBase}>
            <RawAdminPage onLogout={() => navigate(loginBase, { replace: true })} />
          </AuthGuard>
        )}
      />
      <Route path={fallbackPath} element={<Navigate to={adminBase} replace />} />
      <Route path="*" element={<Navigate to={adminBase} replace />} />
    </Routes>
  );
}

export default function CoreThemeAdminApp(props) {
  return (
    <BrowserRouter>
      <CoreThemeAdminRoutes {...props} />
    </BrowserRouter>
  );
}
